module.exports = __webpack_public_path__ + "static/media/human.da4666ad.svg";